import { StylesConfig } from "react-select";

const defaultSelectStyle: StylesConfig = {
  menu: (base) => ({ ...base, zIndex: 11 }),
  input: (base) => ({
    ...base,
    height: 48,
  }),
  control: (base, state) => ({
    ...base,
    border: state.isFocused ? "1px solid #85abb4" : "1px solid #ced4da",
    boxShadow: state.isFocused
      ? "0 0 0 0.25rem rgb(11 86 105 / 25%)"
      : undefined,
    "&:hover": state.isFocused ? "1px solid #85abb4" : undefined,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#85abb4" : undefined,
    "&:hover": {
      backgroundColor: state.isSelected ? undefined : "rgb(11 86 105 / 25%)",
    },
    "&:active": {
      backgroundColor: "#85abb4",
    },
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: "#ced4da",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
  }),
};

export default defaultSelectStyle;
